import type { LayerConfigMap } from '@growtherapy/analytics/client';

import { INTAKE_SUMMARY_LAYER_PARAM, PROVIDER_INTAKE_REVIEW_LAYER } from './delayedExperiments';
import { ExperimentLayers } from './experiments';

const [
  FOLLOW_UP_SCHEDULING_LAYER,
  {
    shouldSeeFollowUpNudge: SHOULD_SEE_FOLLOW_UP_NUDGE_PARAM,
    shouldSeeWaitingRoomScheduleCta: SHOULD_SEE_WAITING_ROOM_SCHEDULE_CTA_PARAM,
  },
] = ExperimentLayers.FollowUpScheduling;

/**
 * Minimal layer config for delayed experiments that telehealth participates in.
 * Banner UI stays in the provider portal; telehealth only needs allocation + experience.
 */
export const LAYER_CONFIGS = {
  [PROVIDER_INTAKE_REVIEW_LAYER]: {
    exposurePages: ['/provider', '/provider/*'],
    team: 'care-delivery',
    params: {
      [INTAKE_SUMMARY_LAYER_PARAM]: {
        param: INTAKE_SUMMARY_LAYER_PARAM,
        fallback: false,
        evaluationSource: 'client',
        logExposureAt: 'client',
        applyPages: ['/provider', '/provider/*'],
        waitFor: ['userAuthenticated'],
        exposureMechanism: 'component',
      },
    },
  },
  [FOLLOW_UP_SCHEDULING_LAYER]: {
    exposurePages: ['/provider', '/provider/*'],
    team: 'care-delivery',
    params: {
      [SHOULD_SEE_FOLLOW_UP_NUDGE_PARAM]: {
        param: SHOULD_SEE_FOLLOW_UP_NUDGE_PARAM,
        fallback: false,
        evaluationSource: 'client',
        logExposureAt: 'client',
        applyPages: ['/provider', '/provider/*'],
        waitFor: ['userAuthenticated'],
        exposureMechanism: 'component',
      },
      [SHOULD_SEE_WAITING_ROOM_SCHEDULE_CTA_PARAM]: {
        param: SHOULD_SEE_WAITING_ROOM_SCHEDULE_CTA_PARAM,
        fallback: false,
        evaluationSource: 'client',
        logExposureAt: 'client',
        applyPages: ['/provider', '/provider/*'],
        waitFor: ['userAuthenticated'],
        exposureMechanism: 'component',
      },
    },
  },
} as const satisfies LayerConfigMap;
